import { createTheme } from "@mui/material/styles";

const theme = {
    palette: {
        type: 'light',
        primary: {
            main: '#1577E7',
        },
        secondary: {
            main: '#0F2E69',
        },
        background: {
            paper: '#ffffff',
            default: '#ffffff',
        },
        text: {
            primary: '#232324',
            secondary: '#6E6B6C',
        },
        error: {
            main: '#EB3412',
        },
        success: {
            main: '#4DA700',
        },
        warning: {
            main: '#EF8E09',
        },
        info: {
             main: '#1577E7',
        },
        divider: '#D9D9D9',
    },
    typography: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeightRegular: 500,
        h1: {
            fontWeight: 600,
            color: '#0F2E69',
            margin: 0,
            textTransform: 'uppercase',
        },
        h2: {
            fontWeight: 500,
        },
        h3: {
            fontWeight: 700,
            color: '#0F2E69',
            margin: 0,
            textTransform: 'uppercase',
            fontSize: 16,
        },
        },
        spacing: 8,
        shape: {
        borderRadius: 0,
    },
    props: {
        MuiAppBar: {
          color: 'transparent',
        },
    },
} as const;

type CustomTheme = {
  [Key in keyof typeof theme]: typeof theme[Key];
};

declare module "@mui/material/styles/createTheme" {
  interface Theme extends CustomTheme {}
  interface ThemeOptions extends CustomTheme {}
}

export default createTheme(theme);
